import React, { useContext, useEffect, useState } from "react";
import "./SocialMedia.css";
import { NavLink, useNavigate } from "react-router-dom";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import { Grid } from "@mui/material";
import {
  AnalysisButton,
  ButtonContainer,
  CalenderButton,
  DescriptionText,
  GradientTextButton,
} from "./style";
import PageHeading_V2 from "../../Components_V2/PageHeading/PageHeading";

const SocialMeadiaMarketing_V2 = () => {
  const [completeAnalysis, setCompleteAnalysis] = useState(false);
  const [scheduled, setScheduled] = useState(false);
  const [partialScheduled, setPartialScheduled] = useState(false);
  const [scheduledData, setScheduledData] = useState([]);
  const [result, setResult] = useState([]);
  const [allTime, setAllTime] = useState("");
  const { AIuser, AiLogOut } = useContext(UserAuthContext);
  const navigate = useNavigate();
  const [startAnalysis, setStartAnalysis] = useState(false);

  useEffect(() => {
    fetch("https://backend.whalesai.com/api/v1/social/analyses/all")
      .then((res) => res.json())
      .then((data) =>
        setResult(data.filter((item) => item?.userId === AIuser?._id))
      );
  }, []);

  useEffect( () => {
    fetch(`https://backend.whalesai.com/api/v1/social-schedule/schedules/email/${AIuser?.email}`). then(res => res.json()) .then(data => setScheduledData(data))
  }, [AIuser?.email]);

  useEffect(() => {
    if (scheduledData?.length > 0) {
      const times = scheduledData?.map(item => item.timeOfPosting);
      setAllTime(times);
    }
  }, [scheduledData]);

  console.log('amar schedule data',scheduledData, allTime);

  useEffect( () => {
   if(scheduledData?.length !== 0) {
    // setScheduled(true)
    if (scheduledData?.length !== 10) {
      console.log('Yesssssssssssss');
      setPartialScheduled(true);
      setScheduled(false);
    }
    else{
      setScheduled(true);
      setPartialScheduled(false);
    }
   }
   else setScheduled(false);
  } ,[scheduledData, allTime])



  useEffect(() => {
    if (result.length > 0) setCompleteAnalysis(true);
  }, [result]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const handleAnalysis = () => {
    // Logic to handle analysis start
    setStartAnalysis(true);
  };
  return (
    <div>
      <PageHeading_V2 title="LET US DO IT FOR YOU" />
      <div>
        <p className="text-white w-2-3 text-center mx-auto mt-5">
          Our SOCIAL MEDIA MARKETING MANAGER AI (SMMM AI) automatically generates and uploads content to social media platforms based on detailed analysis conducted by our AI.
        </p>
      </div>

      <div className=" mt-5 mb-5">
        <ButtonContainer>
          <Grid container spacing={6}>
            <Grid item md={6} sm={12} p={2} width={"100%"}>
            {completeAnalysis?
              <AnalysisButton
                onClick={() => navigate(AIuser ? "/ver2/analysis" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })}
              >
                View Analysis
              </AnalysisButton>
              :
              <AnalysisButton
                onClick={() => navigate(AIuser ? "/ver2/analysis" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })}
              >
                Analysis
              </AnalysisButton>
             }

             {completeAnalysis?
             <GradientTextButton
                onClick={() => navigate(AIuser ? "/ver2/analysis" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })}
                className="complete-analysis-animate2 p-visibility"
              >
                You have done your analysis. <br/>Please click here
                to View.
              </GradientTextButton>
              :
              <GradientTextButton
                    onClick={() => 
                      navigate(AIuser ? "/ver2/analysis" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })
                    }
                    className="complete-analysis-animate p-visibility"
                  >
                    You have not done your analysis. <br/>Please click here
                    to do.
              </GradientTextButton>
            }
              
              {completeAnalysis?
              <GradientTextButton
                onClick={() => 
                  navigate(AIuser ? "/ver2/analysis" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })
                }
                className="complete-analysis-animate2 span-visibility"
              >
                You have done your analysis.
                Please click here to view.
              </GradientTextButton>
              :
              <GradientTextButton
                onClick={() => 
                  navigate(AIuser ? "/ver2/analysis" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })
                }
                className="complete-analysis-animate span-visibility"
              >
                You have not done your analysis.
                Please click here to do.
              </GradientTextButton>
             }

            </Grid>
            <Grid item md={6} sm={12} p={2} width={"100%"}>
              <CalenderButton
                onClick={() =>
                  navigate(AIuser ? "/ver2/calendars" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })
                }
              >
                Calendars
              </CalenderButton>
              
              {
                partialScheduled && <GradientTextButton
                onClick={() => navigate(AIuser ? "/ver2/calendars" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })}
                className="complete-analysis-animate2 p-visibility"
              >
                You have done your scheduling partially. <br/>
                Please click here to check.
              </GradientTextButton>
              }
              {
                scheduled && <GradientTextButton
                onClick={() => navigate(AIuser ? "/ver2/calendars" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })}
                className="complete-analysis-animate2 p-visibility"
              >
                You have done your scheduling fully. <br/>
                Please click here to check.
              </GradientTextButton>
              }

              {
                !partialScheduled && !scheduled && <GradientTextButton
                onClick={() => navigate(AIuser ? "/ver2/calendars" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })}
                className="complete-analysis-animate p-visibility"
              >
                You have not planned your contents. <br/> Please click here to do.
              </GradientTextButton>
              }


             {
                partialScheduled && <GradientTextButton
                onClick={() => navigate(AIuser ? "/ver2/calendars" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })}
                className="complete-analysis-animate2 span-visibility"
              >
                You have done your scheduling partially. <br/>
                Please click here to check.
              </GradientTextButton>
              }
              {
                scheduled && <GradientTextButton
                onClick={() => navigate(AIuser ? "/ver2/calendars" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })}
                className="complete-analysis-animate2 span-visibility"
              >
                You have done your scheduling fully. <br/>
                Please click here to check.
              </GradientTextButton>
              }

              {
                !partialScheduled && !scheduled && <GradientTextButton
                onClick={() => navigate(AIuser ? "/ver2/calendars" : "/sign-in", { state: { from: "/ver2/let-us-do-it-for-you" } })}
                className="complete-analysis-animate span-visibility"
              >
                You have not planned your contents. <br/> Please click here to do.
              </GradientTextButton>
              }
            </Grid>
          </Grid>
        </ButtonContainer>
      </div>

      <p className="text-to complete-analysis-animate mb-5 text-center ">
      </p>
    </div>
  );
};

export default SocialMeadiaMarketing_V2;
